/**
 * Track route — landing for `/track` (no tracking number yet). Shows the
 * UPU S10 lookup form; on submit, the form navigates to
 * `/track/:trackingNumber` which renders `TrackingRoute`.
 *
 * The LandingPage hero CTA links here; this is the full-page wrapper for the
 * lookup form so a user who clicks "Track a Package" doesn't end up on the
 * marketing page below the fold.
 */
import type { JSX } from 'react';

import { TrackingLookupForm } from '../features/track/TrackingLookupForm';

export function TrackRoute(): JSX.Element {
  return (
    <section className="space-y-8 py-8">
      <header className="space-y-3 text-center">
        <p className="text-sm font-semibold uppercase tracking-wider text-nipost-600">
          NIPOST tracking
        </p>
        <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">
          Track your NIPOST mail
        </h1>
        <p className="mx-auto max-w-xl text-sm text-slate-600">
          Enter the 13-character tracking number from your receipt or
          notification. Updates appear here as your item moves through the
          NIPOST network.
        </p>
      </header>
      <div className="mx-auto max-w-xl rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <TrackingLookupForm />
        <p className="mt-3 text-xs text-slate-500">
          Tip: tracking numbers begin with two letters (RR, EE, CP, or RA),
          followed by 9 digits, ending in NG.
        </p>
      </div>
    </section>
  );
}
